import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const DepartmentApi = createApi({
  reducerPath: "DepartmentApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    //Start Department API's------------------------------------
    getAllDepartmentData: builder.query({
      query: () => "get_all_departments",
      transformResponse: (response) => response?.data || [],
    }),

    addDepartment: builder.mutation({
      query: (addDept) => ({
        url: "add_department",
        method: "POST",
        body: addDept,
      }),
    }),

    editDepartment: builder.mutation({
      query: (editDept) => ({
        url: `update_department`,
        method: "PUT",
        body: editDept,
      }),
    }),

    getDepartmentById: builder.query({
      query: ({ id }) => `get_single_department/${id}`,
      transformResponse: (response) => response?.data || [],
    }),

    deleteDepartment: builder.mutation({
      query: (id) => ({
        url: `delete_department/${id}`,
        method: "DELETE",
      }),
    }),

    //END Department API's--------------------------------------------
  }),
});

export const {
  //department api
  useGetAllDepartmentDataQuery,
  useAddDepartmentMutation,
  useEditDepartmentMutation,
  useGetDepartmentByIdQuery,
  useDeleteDepartmentMutation,
} = DepartmentApi;

export default DepartmentApi;
